





































































import { confirmDelete } from '@/libs/decorator';
import { pagination } from '@/libs/util';
import DatasourceServices, {DatasourceDto} from '@/services/datasource';
import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class DsColumns extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @PropSync('formData') syncFormData! : DatasourceDto;
  @Prop() tableId!: number;
  @Prop() dsType!: string;
  spinning: boolean = false;
  loading: boolean = false;
  pagination = pagination;

  dsSrv = new DatasourceServices();
  childShow = true;
  visible = false;
  selectedRowKeys: number[] = [];
  data: any = [];

  confirm() {}

  @Watch('visible')
  onVisibleChange() {
    if (!this.syncVisible) return false;
    this.getDataList();
  }

  onSelectChange(selectedRowKeys: []) {
    this.selectedRowKeys = selectedRowKeys;
  }

  @confirmDelete()
  async onDelete(ids: number[]) {
    let res = await this.dsSrv.deleteColumns(ids);
    this.getDataList();
  }

  async getDataList() {
    this.loading = true;
    let res = await this.dsSrv.columns({ tableId_eq: this.tableId });
    this.loading = false;
    this.data = res;
    this.childShow = false;
    this.$nextTick(() => {
      this.childShow = true;
    });
  }

  get xWidth() {
    return 1000;
  }

  get yHeight() {
    return 380;
  }

  addList() {
    if (this.data.length > 0) {
      this.data.forEach( (record: any) => {
        if(!record.id) {
          this.$message.warn('请确定提交未提交的新增条目');
          return false;
        }
      });
    }
    this.data.push({
      status: 0
    });
  }

  @confirmDelete()
  async onSingleDelete(id: number, index: number) {
    if (id) {
      let res = await this.dsSrv.deleteColumns([id]);
      if(res) this.getDataList();
    } else {
      this.data.splice(index, 1);
    }
  }

  async onSingeAdd(record: any) {
    if (!record.columnNameEn) {
       this.$message.error('字段物理名不能为空');
       return false;
    }
    if (!record.dataTypeEn) {
       this.$message.error('字段物理类型不能为空');
       return false;
    }
    if(record.pkFlag) {
      record.pkFlag = 1;
    } else {
      record.pkFlag = 0;
    }
    record.tableId = this.tableId;
    let res = await this.dsSrv.saveColumns([record]);
    if(res) this.getDataList();
  }

  async onCellChange(args: string[], record: any, column: string) {
    record[column] = args[0];
    if (record.id) {
      let params = {
        id: record.id,
        [column]: args[0]
      };
      let res = await this.dsSrv.updateColumn(params);
      if (res) this.getDataList();
    }
  }

  handleBatch(e: any) {
    if (this.selectedRowKeys.length === 0) {
      this.$message.error('请选中至少一条数据');
      return false;
    }
    if (e.key == 'removeAll') {
      this.onDelete(this.selectedRowKeys);
    }
    if (e.key === 'batchEnable') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, status: 0 }));
      this.batchUpdate(paramsArr);
    }
    if (e.key === 'batchDisable') {
      let paramsArr = this.selectedRowKeys.map((key: number) => ({ id: key, status: 1 }));
      this.batchUpdate(paramsArr);
    }
  }

  // 批量更新
  async batchUpdate(paramsArr: any[]) {
    this.loading = true;
    let promiseArr = paramsArr.map((param: any) => {
      return new Promise(async resolve => {
        await this.dsSrv.updateColumn(param).then(res => resolve(res));
      });
    });
    await Promise.all(promiseArr);
    this.loading = false;
    this.getDataList();
    this.selectedRowKeys = [];
  }

  async initColumn() {
    this.loading = true;
    this.data = await this.dsSrv.initColumns({ id: this.tableId });
    this.loading = false;
  }

  uploadTemplate(data: any) {
    const formData = new FormData()  
    formData.append('file', data.file)
    formData.set('tableId', this.tableId.toString() )
    this.dsSrv.uploadTemplate(formData);
  }

  columns = [
    { title: '字段物理名', dataIndex: 'columnNameEn', key: 'columnNameEn', scopedSlots: { customRender: 'nameEn' } },
    { title: '字段逻辑名', dataIndex: 'columnNameCn', key: 'columnNameCn', scopedSlots: { customRender: 'nameCn' } },
    { title: '字段物理类型', dataIndex: 'dataTypeEn', key: 'dataTypeEn', scopedSlots: { customRender: 'typeEn' } },
    { title: '字段逻辑类型', dataIndex: 'dataTypeCn', key: 'dataTypeCn', scopedSlots: { customRender: 'typeCn' } },
    { title: '主键', dataIndex: 'pkFlag', key: 'pkFlag', width: 100, scopedSlots: { customRender: 'pkFlag' } },
    { title: '启用', dataIndex: 'status', key: 'status', width: 100, scopedSlots: { customRender: 'status' } },
    { title: '操作', dataIndex: 'operation', key: 'operation', width: 200, scopedSlots: { customRender: 'operation' } }
  ];
}
